<template lang="pug">
  m-table(
    store-name="adminorganizations"
    :headers="headers"
    :query-filter="queryFilter"
    :item-actions="actions"
  )
</template>

<script>
import MTable from '~/components/modules/tables/m-table'
import contentDialogContentTop from '~/mixins/dialogs/contentDialogContentTop'

export default {
  name: 'BlockUserOrganizations',
  components: { MTable },
  mixins: [contentDialogContentTop],
  props: {
    userId: {
      type: String,
      default: null
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'Name',
          value: 'name',
          sortable: false,
          filterable: false
        },
        {
          text: 'Edrpou',
          value: 'edrpou',
          sortable: false,
          filterable: false
        },
        {
          text: 'Public link available (days)',
          value: 'publicLinkAccessPeriod',
          sortable: false,
          filterable: false
        },
        {
          text: 'Date of deletion',
          valueFormatter: organization =>
            organization.deletedAt
              ? this.$moment.parseZone(organization.deletedAt).format('DD.MM.YYYY, HH:mm')
              : '-',
          sortable: false,
          filterable: false
        }
      ]
    },
    queryFilter() {
      return {
        'organizationUsers.user.id': this.userId
      }
    },
    actions() {
      return [
        {
          name: 'details',
          text: 'Organization detail',
          call: organization => this.showOrganizationDetails(organization)
        }
      ]
    }
  },
  methods: {
    showOrganizationDetails(organization) {
      this.contentDialogContentTop.open({
        width: '1000px',
        component: 'm-organization-details',
        componentProps: {
          organization
        }
      })
    }
  }
}
</script>

<style scoped lang="scss"></style>
